/**
 * Payload mappers for website forms.
 */

import type { Website } from "../WebsiteManagement";
import type { CreateWebsiteSuggestionRequest } from "@/services/websiteSuggestion.service";
import type { WebsiteFormData } from "@/utils/websiteFormUtils";

export type AddWebsitePayload = Omit<Website, "id" | "addedAt" | "addedBy">;

export const buildSuggestionPayload = (
  formData: WebsiteFormData,
  normalizedUrl: string
): CreateWebsiteSuggestionRequest => ({
  title: formData.title.trim(),
  description: formData.description.trim(),
  urlLandingPage: normalizedUrl,
  address: formData.address || null,
  zipCode: formData.zipCode || null,
  category1Id: formData.category1Id ?? null,
  categoryPathIds: null,
  regionId: formData.regionId ?? null,
  regionPathIds: null,
});

export const buildAddWebsitePayload = (
  formData: WebsiteFormData,
  normalizedUrl: string
): AddWebsitePayload => ({
  title: formData.title.trim(),
  url: normalizedUrl,
  description: formData.description.trim(),
  address: formData.address.trim() ? formData.address.trim() : null,
  zipCode: formData.zipCode,
  region: formData.regionName,
  regionId: formData.regionId ?? undefined,
  category1Id: formData.category1Id ?? undefined,
  category1Name: formData.category1Name,
  categoryPathIds: formData.categoryPathIds,
  categoryPathNames: formData.categoryPathNames,
  regionPathIds: formData.regionPathIds,
  regionPathNames: formData.regionPathNames,
});
